import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import '../src/components/fonts/fonts.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config';
import { getToken } from './helpers/util';

// Token Interceptor
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  const [resource, config = {}] = args;
  const token = getToken();

  const headers = new Headers(config.headers || {});

  // Add Authorization if token exists
  if (token) {
    headers.set('Authorization', 'Bearer ' + token);
  }

  // Only set Content-Type to JSON if:
  // - it's a method that sends a body
  // - body is NOT FormData
  // - Content-Type isn't already set
  const method = (config.method || 'GET').toUpperCase();
  const isSendingBody = ['POST', 'PUT', 'PATCH'].includes(method);
  const isFormData = config.body instanceof FormData;

  if (isSendingBody && !isFormData && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  config.headers = headers;

  try {
    const response = await originalFetch(resource, config);
    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
